import { ref, computed } from "vue";
import posthog from "posthog-js";
import { isIdentified, resetPostHog } from "./usePostHog";
import { experimentAssigned } from "./useAnalytics";

const IS_QA = import.meta.env.VITE_ENV === "QA";
const FLAG_NAME = IS_QA ? "banking-step-order-qa" : "banking-step-order";

const posthogTestGroup = ref(false);
let initPromise = null;

export function useStepOrderExperiment() {
  function initExperiment() {
    if (!isIdentified()) return Promise.resolve();
    if (initPromise) return initPromise;
    initPromise = new Promise((resolve) => {
      let callbackReady = false;
      let assigned = false;
      posthog.reloadFeatureFlags();
      posthog.onFeatureFlags(() => {
        if (!callbackReady) return;
        if (!isIdentified()) return;
        const flag = posthog.getFeatureFlag(FLAG_NAME);
        if (IS_QA) console.log(`PostHog feature flag '${FLAG_NAME}':`, flag);
        if (flag !== undefined) {
          posthogTestGroup.value = flag === "test";
          if (!assigned) {
            assigned = true;
            experimentAssigned({
              experimentKey: "banking-step-order",
              variant: posthogTestGroup.value ? "test" : "control",
              entryUrl: typeof window !== "undefined" ? window.location.href : null,
            });
          }
        }
        resolve();
      });
      callbackReady = true;
    });
    return initPromise;
  }

  const isInTestGroup = computed(() => posthogTestGroup.value);

  return { initExperiment, isInTestGroup };
}

function overrideExperiment(variant) {
  posthogTestGroup.value = variant === "test";
  try {
    posthog.featureFlags.overrideFeatureFlags({ flags: { [FLAG_NAME]: variant } });
  } catch {
    // PostHog may not be initialized in non-QA environments
  }
}

if (typeof window !== "undefined" && IS_QA) {
  window.__stepOrderExperiment = { override: overrideExperiment };
}

export function clearStepOrderExperimentState() {
  posthogTestGroup.value = false;
  initPromise = null;
  resetPostHog();
}
